import { Table, Modal, Typography, Popconfirm } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import ReceivableAccountForm from "./ReceivableAccountForm";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";

const ReceivableAccountListing = () => {
  const [receivableAccount, setReceivableAccount] = useState(false);
  const [receivableAccountDetails, setReceivableAccountDetails] = useState([]);
  const [editingAccount, setEditingAccount] = useState(null);

  // Function to fetch receivable accounts
  const fetchReceivableAccounts = () => {
    axios.get("/manualPayment/receivableAccountDetails").then(({ data }) => {
      setReceivableAccountDetails(data.receivableAccountDetails);
    });
  };

  // Fetch data on mount
  useEffect(() => {
    fetchReceivableAccounts();
  }, []);

  const handleCloseModal = () => {
    setReceivableAccount(false);
    setEditingAccount(null); // This resets form data
  };

  // Handle delete action
  const handleDelete = (id) => {
    axios
      .post(`/manualPayment/deleteReceivableAccount/${id}`)
      .then(() => {
        fetchReceivableAccounts(); // Refresh list after deletion
      })
      .catch((err) => console.error("Error deleting:", err));
  };

  const columns = [
    {
      title: "Account Owner Name",
      dataIndex: "vendor_name",
      key: "vendor_name",
    },
    {
      title: "Account Number",
      dataIndex: "receivable_account_number",
      key: "receivable_account_number",
      render: (text) => `****${text}`,
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Stack direction="row" spacing={1}>
          {/* Edit Button */}
          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            onClick={() => {
              setEditingAccount(record); // Pass record to form
              setReceivableAccount(true);
            }}
          >
            Edit
          </Button>

          {/* Delete Button */}
          <Popconfirm
            title="Are you sure to delete?"
            onConfirm={() => handleDelete(record.receivable_account_id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="button"
              danger
            >
              Delete
            </Button>
          </Popconfirm>
        </Stack>
      ),
    },
  ];
  return (
    <div>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <AttachMoneyOutlinedIcon
          style={{
            height: "5%",
            width: "5%",
            marginTop: 2.5,
          }}
        />
        <Typography sx={{ fontWeight: "bold" }}>
          Receivable Account:{" "}
        </Typography>

        <Button
          size="small"
          type="button"
          variant="contained"
          color="primary"
          onClick={(e) => {
            setReceivableAccount(true);
          }}
        >
          Add
        </Button>
      </Stack>

      <Table
        style={{ marginTop: 2 }}
        columns={columns}
        rowKey="receivable_account_id"
        dataSource={receivableAccountDetails}
        pagination={false}
        bordered
      />
      <Modal
        destroyOnClose={true}
        width="400px"
        title="Receivable Account"
        open={receivableAccount}
        onCancel={handleCloseModal}
        footer={false}
      >
        <ReceivableAccountForm
          fetchReceivableAccounts={fetchReceivableAccounts}
          setReceivableAccount={setReceivableAccount}
          editingAccount={editingAccount}
        />
      </Modal>
    </div>
  );
};

export default ReceivableAccountListing;
